import React, { useState } from "react";
import {
  Header,
  Button,
  Paragraph
} from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import * as CONST from "../../../app/constants";
import { push } from "connected-react-router";
import { useDispatch, useSelector } from "react-redux";

import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import {
  applicationTypeFromLicenceSubType
} from "../../../redux/slice/applicationsUtils";
import CheckBoxForm from "../../../components/CheckBoxForm";
import { setMortgageProperty } from "../../../redux/slice/primaryAgencyApplicationSlice";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";
import { ERROR_STRING } from "../../../app/errors";

const MORTGAGE_APPLICATION_PROPERTY = "isFinancialStatementSubmitted";

export const ConfirmFinancialStatementSubmission = (props) => {
  const { isModal = false, onEditSave = () => {} } = props;

  const [confirmAIRSubmitted, setConfirmAIRSubmitted] = useState(false);
  const [applicationSaveError, setApplicationSaveError] = useState(false);

  const { agencyApplication } = useSelector(agencyApplicationSelector);

  const serverSaveRequest = useSelector(
    (state) => state.primaryAgencyApplication.serverRequestStatus
  );

  const dispatch = useDispatch();

  const handleContinue = () => {
    const update = {
      key: MORTGAGE_APPLICATION_PROPERTY,
      value: confirmAIRSubmitted
    };

    dispatch(setMortgageProperty(update));

    const applicationType = applicationTypeFromLicenceSubType(agencyApplication.licencingSubType);

    dispatch(saveBusinessLicenceApplicationData(applicationType, CONST.APPLICATION_MODE_RENEW))
      .then((data) => {
        if (isModal) {
          onEditSave();
        } else {
          let nextUrl = "";

          if (applicationType === CONST.APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE) {
            nextUrl = `${CONST.ROUTE_PATH.MA_APP}${CONST.ROUTE_PATH.RENEWAL_APPOINTED_AGENT_SERVICE_ADDRESS}`;
          }

          dispatch(push(nextUrl));
        }
      })
      .catch((err) => {
        setApplicationSaveError(true);
      });
  };

  return (
    <div className={!isModal ? "container" : ""}>
      {!isModal && <TopNavigationBar {...props} />}

      <div className="row">
        {!isModal && (
          <div className="col-xs-12 col-lg-11">
            <Header id="mra-renewal-confirm-financial-statements-header" header="Financial Statements" />
          </div>
        )}
        <div className="col-xs-12 col-lg-11 topMarginMedium">
          <Paragraph
            id="mra-renewal-confirm-financial-statements-text-1"
            style={{ fontWeight: "bold", fontSize: "1.2em" }}
            text={[
              "Financial Statements required under section 55 of the Mortgage Regulation Act (MRA) are mandatory for your renewal."
            ]}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12 col-lg-9">
          <CheckBoxForm
            id="confirm-financial-submission-checkbox"
            checked={confirmAIRSubmitted}
            value={confirmAIRSubmitted}
            labelText="Have you submitted your Financial Statements to mortgageregulation@novascotia.ca?"
            onCheckBoxChange={(val) => {
              setConfirmAIRSubmitted(val);
            }}
          />
        </div>
      </div>

      <div className="row">
        <div className={"col-lg-8"}>
          <div className="col-xs-3">
            <Button
              className="btn-lg btn-default"
              buttonType={"regular_primary"}
              text={!isModal ? "Continue" : "Save and close"}
              showSpinner={serverSaveRequest === CONST.REQUEST_STATUS.IN_PROGRESS}
              disabled={serverSaveRequest === CONST.REQUEST_STATUS.IN_PROGRESS}
              onClick={handleContinue}
            />
          </div>
        </div>
      </div>
      {applicationSaveError && (
        <div className="ns-error-message help-block topMarginNormal">
          <span className="ns-visually-hidden">Error:</span>
          {ERROR_STRING.APPLICATION_SAVE_ERROR}
        </div>
      )}
    </div>
  );
};
